import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import events from '@/hooks/events';
import actions from '../constants';

const useShowValidateDictionaryDataStatus = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(
    ({ dictionaryCode, dictionaryName, inDialog }) => handler({
      type: actions.SHOW_VALIDATE_DICTIONARY_DATA_STATUS,
      category,
      code,
      dictionaryCode,
      dictionaryName,
      inDialog,
    }),
    [category, code],
  );
};

const useValidateDictionaryData = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(
    ({ dictionaryCode }) => handler({
      type: actions.VALIDATE_DICTIONARY_DATA, category, code, dictionaryCode,
    }),
    [category, code],
  );
};

const useConvertDatasetData = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(
    ({ name }) => handler({
      type: actions.CONVERT_DATASET_DATA, category, code, name,
    }),
    [category, code],
  );
};

const useConvertDictionaryData = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(
    ({ dictionaryCode, dictionaryName }) => handler({
      type: actions.CONVERT_DICTIONARY_DATA, category, code, dictionaryCode, dictionaryName,
    }),
    [category, code],
  );
};

const useHideValidateDataResultsDialog = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(
    ({ dictionaryCode }) => handler({
      type: actions.HIDE_VALIDATE_DATA_RESULTS_DIALOG, category, code, dictionaryCode,
    }),
    [category, code],
  );
};

const useHideValidationServerErrors = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(
    ({ errors }) => handler({
      type: actions.HIDE_VALIDATION_SERVER_ERRORS, category, code, errors,
    }),
    [category, code],
  );
};

export default {
  useValidateDatasetData: (category, { code }) => events.useDispatchByCode(
    actions.VALIDATE_DATASET_DATA,
    category,
    code,
  ),
  useShowValidateDictionaryDataStatus,
  useValidateDictionaryData,
  useConvertDatasetData,
  useConvertDictionaryData,
  useHideValidateDataResultsDialog,
  useHideValidationServerErrors,
};
